import { CUSTOM_SCROLLBAR_CSS } from "App/CUSTOM_SCROLLBAR_CSS";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import PnlSummaryChart from "components/Dashboard/PnlSummaryChart/PnlSummaryChart";
import { getPnlChartResponsiveStyles } from "components/Dashboard/styles/getDashboardCardsResponsiveStyles";
import { BREAKPOINT_DESKTOP_XL, BREAKPOINT_TABLET } from "constants/constants";
import { getScaleFromWidthForLargeScreens } from "pages/DashboardPages/DashboardPagesContent/dashboardPagesContentUtils";
import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";

export function GridLayoutPnlChart({ width }: { width: number }) {
  const { translate } = useFlightTranslation();
  const scale = getScaleFromWidthForLargeScreens(width);
  return (
    <CardWithControls title={translate("PnL_Breakdown")}>
      <GridLayoutPnlChartStyles {...{ $scale: scale }}>
        <PnlSummaryChart />
      </GridLayoutPnlChartStyles>
    </CardWithControls>
  );
}
const GridLayoutPnlChartStyles = styled.div<{ $scale: number }>`
  box-sizing: border-box;
  height: 100%;
  ${CUSTOM_SCROLLBAR_CSS};
  padding: 16px;
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    padding: 16px 46px;
  }
  @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
    ${props => getPnlChartResponsiveStyles(props.$scale * 1.75)}
  }
`;
